import React from 'react'

import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd';

import { CarouselItem } from 'generated/mos/org/getty/audio'
import { Media } from 'generated/mos/media';

import { bffEndpoint } from 'helpers/bff'
import { dndReorder } from 'helpers/drag-and-drop';

import { MediaCarouselItem } from './media-carousel-item';

type Props = {
  readonly deleteHandler: (carouselItem: CarouselItem.Ref) => void;
  readonly stopImageRef?: Media.Ref;
  readonly historyPush: (id: string) => void;
  readonly mediaList: ReadonlyArray<Media.Entity> | undefined;
  readonly orderedCarouselItems: ReadonlyArray<CarouselItem.Entity>;
  readonly projectId: string;
  readonly setOrderedCarouselItems: React.Dispatch<React.SetStateAction<ReadonlyArray<CarouselItem.Entity>>>;
  readonly stopId: string;
  readonly tourId?: string;
}

export const ReorderableCarouselItems = (props: Props) => {
  const {
    deleteHandler,
    stopImageRef,
    historyPush,
    mediaList,
    orderedCarouselItems,
    projectId,
    setOrderedCarouselItems,
    stopId,
    tourId,
  } = props


  const hostName = bffEndpoint(window.location.hostname)

  const onDropHandler = (dropResult: DropResult) => {
    const updatedOrder: ReadonlyArray<CarouselItem.Entity> = dndReorder(dropResult, orderedCarouselItems)
    setOrderedCarouselItems(updatedOrder)
  }

  return (
    <>
      <MediaCarouselItem
        historyPush={historyPush}
        isHeroImage={true}
        isDragging={false}
        mediaList={mediaList}
        projectId={projectId}
        stopId={stopId}
        stopImageRef={stopImageRef}
        hostName={hostName}
      />
      <DragDropContext onDragEnd={(dropResult) => {
        onDropHandler(dropResult)
      }}>
        <Droppable droppableId="carousel-items-list">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {orderedCarouselItems.map((carouselItem, index) => {
                const id = carouselItem.ref ? carouselItem.ref.id : ''
                return (
                  <>
                    <Draggable draggableId={id} key={id} index={index}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <MediaCarouselItem
                            carouselItem={carouselItem}
                            draggableIndex={index + 1} // +1 because the hero image carousel item is not included in the list
                            deleteHandler={deleteHandler}
                            historyPush={historyPush}
                            isDragging={snapshot.isDragging}
                            mediaList={mediaList}
                            projectId={projectId}
                            stopId={stopId}
                            tourId={tourId}
                            hostName={hostName}
                          />
                        </div>
                      )}
                    </Draggable>
                  </>
                )
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  )
}
